import { render } from "./DashInfoComponent.vue?vue&type=template&id=0bd0e8c4&scoped=true"
import script from "./DashInfoComponent.vue?vue&type=script&lang=js"
export * from "./DashInfoComponent.vue?vue&type=script&lang=js"

import "./DashInfoComponent.vue?vue&type=style&index=0&id=0bd0e8c4&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd0e8c4"]])

export default __exports__